import Head from 'next/head';

import { useGlobalContext } from '@/hooks/use-global_context';

export const CustomHead = () => {
  const { liff } = useGlobalContext();
  const isLiff = liff?.isInClient;

  return (
    <Head>
      <meta charSet='UTF-8' />
      <meta
        name='viewport'
        content='width=device-width, initial-scale=1.0, user-scalable=no, maximum-scale=1.0, viewport-fit=cover'
      />
      <meta name='format-detection' content='telephone=no' />
      <meta
        name='description'
        content='薬局ミニアプリ - 薬局でのサービスを便利に利用できます'
      />
      {/* LIFFアプリ内でのみ適用される設定 */}
      {isLiff && <meta name='robots' content='noindex' />}

      <title style={{ display: isLiff ? 'none' : 'block' }}>
        薬局ミニアプリ
      </title>
    </Head>
  );
};
